import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ActionModal } from '@/components/ui/ActionModal';
import { useUiStore } from '@/store/uiStore';
import { ACCOUNT_SETTINGS_PATH } from '@/routes/paths';

/** Shown when echo creation is gated on a missing Stripe Connect account. */
export const StripeRequiredModal: React.FC = () => {
  const isOpen = useUiStore((state) => state.modals.stripeRequired);
  const closeModal = useUiStore((state) => state.closeModal);
  const navigate = useNavigate();

  const handleGoToAccount = () => {
    navigate(ACCOUNT_SETTINGS_PATH);
    closeModal('stripeRequired');
  };

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={() => closeModal('stripeRequired')}
      title='Stripe Account Required'
      message='You need an active Stripe account to create an Echo. Set up your payment account to get started.'
      primaryLabel='Go to Account'
      onPrimary={handleGoToAccount}
      secondaryLabel='Maybe Later'
    />
  );
};
